import { useMemo } from "react"

import { useRoutes } from "react-router-dom"

import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { MODULE_DOCUMENTS, NETWORK_ATTACHMENT, ROAD_ATTACHMENT, SECTION_ATTACHMENT } from "../../constants/modules"
import { DocumentAttachedObjectSidebar } from "../../containers/DocumentAttachedObjectSidebar"
import { DocumentRoadSidebar } from "../../containers/DocumentRoadSidebar"
import { DocumentSidebar } from "../../containers/DocumentSidebar"

import * as Styled from "./SidebarRouter.styled"

export const SidebarRouter = () => {
    const isMobile = useIsMobileDevice()

    const sidebarRoutes = useMemo(() => ([
        {
            path: `/${MODULE_DOCUMENTS}`,
            element: <DocumentSidebar />,
        },
        {
            path: `/${MODULE_DOCUMENTS}/:road`,
            element: <DocumentRoadSidebar />,
        },
        {
            path: `/${MODULE_DOCUMENTS}/attached/${NETWORK_ATTACHMENT}`,
            element: <DocumentAttachedObjectSidebar />,
        },
        {
            path: `/${MODULE_DOCUMENTS}/:road/attached/${ROAD_ATTACHMENT}`,
            element: <DocumentAttachedObjectSidebar />,
        },
        {
            path: `/${MODULE_DOCUMENTS}/:road/attached/${SECTION_ATTACHMENT}`,
            element: <DocumentAttachedObjectSidebar />,
        },
        {
            path: `/${MODULE_DOCUMENTS}/:road/attached/:attachmentType/:attachmentId`,
            element: <DocumentAttachedObjectSidebar />,
        },
    ]), [])

    return <Styled.Sidebar isMobile={isMobile}>{useRoutes(sidebarRoutes)}</Styled.Sidebar>
}